import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  // OIDC auth callbacks
  {
    path: '/auth/signinwin/main',
    name: 'signinwin',
    component: () => import('./auth/components/signinwin.vue'),
  },
  {
    path: '/auth/signinpop/main',
    name: 'signinpop',
    component: () => import('./auth/components/signinpop.vue'),
  },
  {
    path: '/auth/signinsilent/main',
    name: 'signinsilent',
    component: () => import('./auth/components/signinsilent.vue'),
  },
  {
    path: '/auth/signoutpop/main',
    name: 'signoutpop',
    component: () => import('./auth/components/signoutpop.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router